"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

var _fi = require("react-icons/fi");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-pill-container {\n  width: fit-content;\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  border-radius: 1rem;\n  border: 0.0625rem solid #c6c6c6;\n  box-sizing: border-box; }\n  .bds-pill-container:hover {\n    background: #e0e0e0; }\n\n.bds-error-pill {\n  border: 0.125rem solid #da1e28; }\n\n.bds-disabled-pill {\n  border: 0.0625rem solid #c6c6c6; }\n  .bds-disabled-pill:hover {\n    background: #ffffff; }\n\n.bds-read-only-pill {\n  border: 0.0625rem solid #c6c6c6;\n  justify-content: center; }\n  .bds-read-only-pill:hover {\n    background: #ffffff; }\n\n.bds-pill-label {\n  height: 1.1875rem;\n  margin: 0.3125rem 0.5rem 0.375rem 0.9375rem;\n  display: inline;\n  font-size: 0.875rem;\n  font-family: \"OpenSansRegular\";\n  letter-spacing: 0.02rem;\n  color: #393939;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 24rem; }\n\n.bds-pill-label-disabled {\n  color: #c6c6c6; }\n\n.bds-pill-label-read-only {\n  margin-right: 0.9375rem;\n  color: #525252; }\n\n.bds-pill-icon-container {\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n\n.bds-pill-dark-color,\n.bds-pill-light-color {\n  transition: filter 0.2s ease-in-out; }\n\n.bds-pill-dark-color:hover {\n  -webkit-filter: brightness(150%);\n  filter: brightness(150%); }\n\n.bds-pill-light-color:hover {\n  -webkit-filter: brightness(90%);\n  filter: brightness(90%); }\n\n.bds-pill-icon {\n  width: 1rem;\n  height: 1rem;\n  margin: 0.1875rem 0.4375rem 0.1875rem 0rem;\n  color: #6f6f6f; }\n  .bds-pill-icon:hover {\n    color: #0561a7; }\n\n.bds-pill-icon-disabled {\n  color: #c6c6c6; }\n  .bds-pill-icon-disabled:hover {\n    color: #c6c6c6; }\n";
  var fileName = "compone_pill";
  var element = document.querySelector("style[data-sass-component='compone_pill']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Pill = function Pill(_ref) {
  var _pillContainerClasses, _pillLabelClasses, _pillIconClasses;

  var _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      label = _ref.label,
      onDelete = _ref.onDelete,
      pillColor = _ref.pillColor;
  var hasCustomColor = !!pillColor;
  var isDark = pillColor ? (0, _utils.isColorDark)(pillColor) : false;
  var useDarkText = pillColor ? !isDark : true;
  var customStyle = hasCustomColor ? {
    backgroundColor: pillColor,
    color: useDarkText ? '#000' : '#fff'
  } : {};
  var pillContainerClasses = (_pillContainerClasses = {}, _defineProperty(_pillContainerClasses, _constants.classes.container, true), _defineProperty(_pillContainerClasses, _constants.classes.errorPill, error), _defineProperty(_pillContainerClasses, _constants.classes.readOnlyPill, readOnly), _defineProperty(_pillContainerClasses, _constants.classes.disabledPill, disabled), _defineProperty(_pillContainerClasses, _constants.classes.bgDarkColor, hasCustomColor && isDark), _defineProperty(_pillContainerClasses, _constants.classes.bgLightColor, hasCustomColor && !isDark), _pillContainerClasses);
  var pillLabelClasses = (_pillLabelClasses = {}, _defineProperty(_pillLabelClasses, _constants.classes.label, true), _defineProperty(_pillLabelClasses, _constants.classes.readOnlyPillLabel, readOnly), _defineProperty(_pillLabelClasses, _constants.classes.disabledPillLabel, disabled), _pillLabelClasses);
  var pillIconClasses = (_pillIconClasses = {}, _defineProperty(_pillIconClasses, _constants.classes.icon, true), _defineProperty(_pillIconClasses, _constants.classes.disabledPillIcon, disabled), _pillIconClasses);

  var deleteIconClickHandler = function deleteIconClickHandler(event) {
    event.preventDefault();
    !disabled && (onDelete === null || onDelete === void 0 ? void 0 : onDelete(event));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(pillContainerClasses),
    style: customStyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    title: label,
    className: (0, _classnames.default)(pillLabelClasses),
    style: customStyle
  }, label), !readOnly ? /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "pill-close-icon",
    className: _constants.classes.pillIconContainer,
    onClick: deleteIconClickHandler
  }, /*#__PURE__*/_react.default.createElement(_fi.FiX, {
    size: _constants.defaultPillIconSize,
    className: (0, _classnames.default)(pillIconClasses),
    style: {
      color: customStyle.color
    }
  })) : null);
};

Pill.propTypes = {
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  error: _propTypes.default.bool,
  label: _propTypes.default.string.isRequired,
  onDelete: _propTypes.default.func,
  pillColor: _propTypes.default.string
};
var _default = Pill;
exports.default = _default;